<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Acerca de LCU</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page lcu-page-noSpacing">
            <HeroBanner :image="'/assets/heroes/LCU-About.jpg'">
                <section class="section">
                    <h3 class="lcu-hero-h3 lcu-center-text">
                        LEGACY CHRISTIAN UNIVERSITY
                    </h3>
                    <h1 class="lcu-hero-h1 lcu-center-text">
                        Acerca de Nosotros
                    </h1>
                </section>
            </HeroBanner>
            <section class="section-public">
                <div class="section-container">
                    <div class="col-grid-3Offset">
                        <div>
                            <h2 class="lcu-h2">
                                Acerca de LCU
                            </h2>
                        </div>
                        <div>
                            Como institución cristiana, creemos firmemente que el ministerio no es
                            solo conocimiento, sino carácter, servicio y transformación. Nuestro
                            deseo es que cada estudiante sea guiado por el Espíritu Santo, que su
                            vida testifique de Cristo y que su formación marque generaciones. La
                            excelencia en el ministerio comienza con la
                        </div>
                        <div>
                            que su formación marque generaciones. La excelencia en el ministerio
                            comienza con la excelencia en la vida personal, y estas expectativas
                            existen para ayudarte a caminar hacia ese estándar divino.
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public section-public-primary">
                <div class="section-container">
                    <div class="row">
                        <h2 class="lcu-h2 lcu-h2-secondary lcu-center-text">
                            Visión Institucional
                        </h2>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            Legacy Christian University prepara líderes que impactan congregaciones,
                            ciudades y naciones. Nuestra visión es ver una generación de siervos
                            maduros, sanos emocionalmente, firmes en doctrina y apasionados por
                            la misión de Cristo.
                        </div>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            Cada expectativa aquí detallada es parte de un
                            diseño mayor: formar obreros aprobados que puedan edificar el Cuerpo de
                            Cristo con excelencia.
                        </div>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Mensaje de nuestro Rector'"
                                :type="'secondary'"
                                border
                                @on-click="$router.push('/nota-del-presidente')" />
                        </div>
                    </div>
                </div>
            </section>
            <div class="col-tile-grid2">
                <div
                    class="col-tile-item"
                    style="background-image: url('/assets/heroes/book-bag-filtered.jpg');" />
                <div class="col-tile-item">
                    <div class="col-tile-inner">
                        <div class="row">
                            <img
                            class="lcu-tile-icon"
                            src="/assets/books-icon.png"
                            alt="books icon" />
                        </div>
                        <div class="row">
                            <h2 class="lcu-h2">
                                El Señor te llamó y te está equipando
                            </h2>
                        </div>
                        <div class="row">
                            Estás entrando en un tiempo de crecimiento, desafío y gloria. No estás
                            aquí por casualidad: el Señor te escogió, te llamó y te está equipando.
                            Habrá momentos de esfuerzo, disciplina y perseverancia, pero cada paso
                            te acercará más al diseño de Dios para tu vida. Camina con fe, estudia
                            con excelencia y sirve con pasión. Tu formación será la semilla de tu
                            futuro ministerio.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-tile-grid2Reverse">
                <div class="col-tile-item">
                    <div class="col-tile-inner">
                        <div class="row">
                            <img
                                class="lcu-tile-icon"
                                src="/assets/icon-cap.png"
                                alt="books icon" />
                        </div>
                        <div class="row">
                            <h2 class="lcu-h2">
                                Nuestro compromiso es prepararte
                            </h2>
                        </div>
                        <div class="row">
                            Estas expectativas no son reglas rígidas, sino principios que forman el
                            carácter y sostienen el llamado ministerial. Conhumildad, disciplina,
                            integridad y fe, cada estudiante podrá avanzar con éxito en su formación
                            pastoral. Nuestro compromiso es acompañarte, enseñarte y prepararte para
                            la obra del ministerio con excelencia.
                        </div>
                    </div>
                </div>
                <div
                    class="col-tile-item"
                    style="background-image: url('/assets/heroes/graduate-filtered.jpg');" />
            </div>
            <section class="section-public">
                <div class="section-container">
                    <div class="row">
                        <h3 class="lcu-hero-h3 lcu-center-text">
                            LEGACY CHRISTIAN UNIVERSITY
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-section-h1 lcu-center-text">
                            ¡Tu futuro ministerial comienza aquí!
                        </h1>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Aplicar'"
                                @on-click="$router.push('/inscribirse')" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
  <Modal v-model="videoModal" :close="() => { videoModal = false; }">
    <div class="lcu-modal lcu-modal-wide">
       <video-player
        :options="{
          controls: true,
          // poster: '/assets/video-thumb.png',
          sources: [
            {
              src: `${WEB_ASSETS_URL}/public-assets/lcu-welcome-video.mp4`,
              type: 'video/mp4'
            }
          ]
        }" />
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import HeroBanner from '@/components/hero-banner/HeroBanner.vue';
import VideoPlayer from 'ç/video-player/VideoPlayer.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';
import { WEB_ASSETS_URL } from '@/globals/constants';

export default {
  name: 'about-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    ButtonCta,
    Footer,
    MobileControls,
    IphoneBar,
    HeroBanner,
    VideoPlayer,
  },
  data() {
    return {
      videoModal: false,
      WEB_ASSETS_URL,
    };
  },
};
</script>

<style scoped lang="scss">
.lcu-tile-icon {
  width: 69px;
}
</style>
